export const PREFIX_PLACEHOLDER_MODULE_LAYER = "$__PLACEHOLDER_MODULE_LAYER_";

export const PlaceholderModuleLayerMixin = {
  data() {
    return {
      placeholderModuleLayerId: undefined
    };
  },
  mounted() {
    this.$once("module-loaded", () => {
      this.addPlaceholderModuleLayer();
    });
  },
  destroyed() {
    this.removePlaceholderModuleLayer();
  },
  methods: {
    addPlaceholderModuleLayer() {
      this.placeholderModuleLayerId =
        PREFIX_PLACEHOLDER_MODULE_LAYER + this._uid;

      this.map.addLayer({
        id: this.placeholderModuleLayerId,
        type: "fill",
        metadata: {
          hidden: true
        },
        source: {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: []
          }
        }
      });
    },

    removePlaceholderModuleLayer() {
      if (!this.map) return;

      if (this.map.getLayer(this.placeholderModuleLayerId)) {
        this.map.removeLayer(this.placeholderModuleLayerId);
        this.map.removeSource(this.placeholderModuleLayerId);
      }
    }
  }
};
export default PlaceholderModuleLayerMixin;
